export const emptySpace = ' ';
